import React, { useState, useEffect, useRef } from "react";
import { Headers, SlimHeaderFullResponsive } from "design-react-kit";
import configuration from "../Utility/config.json";
import iconSprite from "bootstrap-italia/dist/svg/sprite.svg";
import logo from "../Assets/Img/stemma.webp";
import Repo from "../Utility/Repo";
import { Link, useLocation } from "react-router-dom";
import { useCookies } from "react-cookie";
//import MenuItem from "../Components/MenuItem";
import { Dropdown } from "react-bootstrap";
import { useHistory } from "react-router-dom";

function Header(props) {
  const [cookies] = useCookies();
  const [apiToken] = useState(cookies.api_token);
  const [isOperator, setIsOperator] = useState(false);
  const [width, setWidth] = useState(window.innerWidth);
  let location = useLocation();
  const auth_url = process.env.REACT_APP_AUTH_URL;
  const entity_url = process.env.REACT_APP_ENTITY_URL;

  const queryParameters =
    entity_url +
    "&returnUrl=" +
    window.location.protocol +
    "//" +
    window.location.host +
    props.subfolder;

  useEffect(() => {
    function handleResize() {
      setWidth(window.innerWidth);
    }
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [width]);

  useEffect(() => {
    if (cookies.user_profile) {
      if (cookies.user_profile.WorkingEntityId) {
        setIsOperator(true);
      }
    }
  }, [cookies]);

  const deleteToken = () => {
    cookies.remove("token_key");
    window.location.href = props.subfolder + "/home";
  };

  const matchMenu = (urlName) => {
    if (
      location.pathname.toLowerCase().includes(urlName?.toLowerCase()) &&
      urlName != "/"
    ) {
      return true;
    } else if (
      (location.pathname == "/Home" || location.pathname == "/") &&
      urlName == "/"
    ) {
      return true;
    }
  };

  const MenuItem = ({ item }) => {
    const [isOpen, setIsOpen] = useState(false);
    const ref = useRef(null);
    const history = useHistory();

    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    useEffect(() => {
      document.addEventListener("click", handleClickOutside, true);
      return () => {
        document.removeEventListener("click", handleClickOutside, true);
      };
    }, []);

    return (
      <li className="nav-item">
        {item.submenu ? (
          <Dropdown ref={ref} show={isOpen} onToggle={() => setIsOpen(!isOpen)}>
            <Dropdown.Toggle
              id={`dropdown-${item.testo}`}
              variant="Secondary-drop"
              style={{ width: "150px" }}
              onClick={() => setIsOpen(!isOpen)}
            >
              {item.testo}
            </Dropdown.Toggle>
            <Dropdown.Menu className="shadow-lg">
              {item.submenu.map((subItem, index) => (
                <Dropdown.Item
                  key={index}
                  onClick={() => {
                    setIsOpen(false);
                    history.push(subItem.url);
                  }}
                >
                  {subItem.testo}
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>
        ) : (
          <Link
            {...(matchMenu(item.url)
              ? {
                  className: "nav-link active customLink",
                }
              : { className: "nav-link customLink" })}
            to={item.url}
          >
            <span style={{ width: "max-content" }}>{item.testo} </span>
            <span className="sr-only">current</span>
          </Link>
        )}
      </li>
    );
  };

  const login = () => {
    return (
      <a
        href={auth_url + configuration.AUTH_PATH_LOGIN + queryParameters}
        className="btn btn-primary btn-sm"
      >
        Accedi
      </a>
    );
  };

  const notify = () => {
    return (
      <>
        <div className="it-horn-wrapper nav-item dropdown">
          <Link
            to="/#"
            className="btn btn-primary btn-icon btn-full"
            data-toggle="dropdown"
            aria-expanded="false"
          >
            <span className="rounded-icon">
              <svg className="icon icon-primary">
                <use href={`${iconSprite}#it-horn`} />
              </svg>
            </span>
          </Link>
          <div
            className="dropdown-menu"
            x-placement="bottom-start"
            style={{
              position: "absolute",
              willChange: "transform",
              top: "0px",
              left: "0px",
              transform: "translate3d(0px, 48px, 0px)",
            }}
          >
            <React.Fragment className="p-3">
              <strong> Notifiche </strong>
              <div> caaa</div>
            </React.Fragment>
          </div>
        </div>
      </>
    );
  };

  const logout = () => {
    return (
      <>
        <div className="it-user-wrapper nav-item dropdown">
          <Link
            to="/#"
            className="btn btn-primary btn-icon btn-full"
            data-toggle="dropdown"
            // aria-haspopup="true"
            aria-expanded="false"
          >
            <span className="rounded-icon">
              <svg className="icon icon-primary ml-0">
                <use href={`${iconSprite}#it-user`} />
              </svg>
            </span>
            <span className="d-none d-lg-block">{props.Name} </span>
          </Link>
          <div
            className="dropdown-menu"
            x-placement="bottom-start"
            style={{
              position: "absolute",
              willChange: "transform",
              top: "0px",
              left: "0px",
              transform: "translate3d(0px, 48px, 0px)",
            }}
          >
            <div className="link-list-wrapper">
              <ul className="link-list ">
                {!isOperator && (
                  <li>
                    <Link className="list-item" to="/profilo">
                      <svg className="icon icon-primary">
                        <use xlinkHref={`${iconSprite}#it-user`}></use>
                      </svg>

                      <span className="ml-1">
                        <b>Profilo</b>
                      </span>
                    </Link>
                  </li>
                )}
                <li>
                  <a
                    className="list-item"
                    href={
                      auth_url +
                      configuration.AUTH_PATH_LOGOUT +
                      queryParameters
                    }
                  >
                    <svg className="icon icon-primary">
                      <use xlinkHref={`${iconSprite}#it-external-link`}></use>
                    </svg>

                    <span className="ml-1">
                      <b>Esci</b>
                    </span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </>
    );
  };

  return (
    <>
      <header className="it-header-wrapper it-header-sticky bg-primary-custom">
        <div className="it-header-slim-wrapper">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="it-header-slim-wrapper-content">
                  <a
                    href="https://www.regione.puglia.it/"
                    style={{ fontSize: "12px" }}
                    target="_blank"
                  >
                    Regione Puglia
                  </a>
                  <div className="it-header-slim-right-zone ">
                    {apiToken &&
                      isOperator &&
                      process.env.REACT_APP_URL_ISTANZE && (
                        <div className="nav-item d-none d-lg-block mr-3">
                          <a
                            href={`${process.env.REACT_APP_URL_ISTANZE}`}
                            style={{ fontSize: "14px" }}
                            rel="noopener noreferrer"
                          >
                            Istanze al cittadino
                          </a>
                        </div>
                      )}
                    <div className="it-access-top-wrapper">
                      {apiToken ? logout() : login()}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="it-nav-wrapper">
          <div className="it-header-center-wrapper">
            <div className="container">
              <div className="it-header-center-content-wrapper ">
                <div className="it-brand-wrapper px-0 mx-0">
                  <div className="row">
                    {width < 992 ? (
                      <>
                        <div className="col-2 mt-4">
                          <a>
                            <button
                              className="custom-navbar-toggler"
                              type="button"
                              aria-controls="nav02"
                              aria-expanded="false"
                              aria-label="Toggle navigation"
                              data-target="#nav02"
                            >
                              <svg className="icon">
                                <use
                                  href={`${iconSprite}#it-burger`}
                                  width="70%"
                                />
                              </svg>
                            </button>
                          </a>
                        </div>
                        <div className="col-10 mt-1">
                          <a href="https://www.ambito3.it/">
                            <img
                              height="91"
                              width="200"
                              src={logo}
                              alt="logo"
                              className="mr-2"
                            />
                            <div className="it-brand-text">
                              <h2
                                style={{ display: "inline" }}
                                className="no_toc "
                              ></h2>
                            </div>
                          </a>
                        </div>
                      </>
                    ) : (
                      <div className="col-12 mt-1">
                        <a href="https://www.ambito3.it/">
                          <img
                            height="91"
                            width="200"
                            src={logo}
                            alt="logo"
                            className="mr-2"
                          />
                          <div className="it-brand-text">
                            <div className="it-brand-title title"></div>
                            <div className="it-brand-tagline d-none d-md-block subtitle"></div>
                          </div>
                        </a>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <Headers shadow={false} sticky>
            <div className="it-header-navbar-wrapper ">
              <div className="container">
                <div className="row">
                  <div className="col-12">
                    <nav className="navbar navbar-expand-lg has-megamenu">
                      <div
                        className="navbar-collapsable expanded"
                        id="nav02"
                        style={{ display: "none", width: "80%" }}
                      >
                        <div
                          className="overlay"
                          style={{ display: "none" }}
                        ></div>
                        <div className="close-div">
                          <button className="btn close-menu" type="button">
                            <svg className="icon">
                              <use href={`${iconSprite}#it-close-big`} />
                            </svg>
                          </button>
                        </div>
                        <div className="menu-wrapper">
                          <ul className="navbar-nav">
                            {props.links &&
                              props.links.map((linkObb, index) => (
                                <MenuItem key={index} item={linkObb} />
                              ))}
                          </ul>
                        </div>
                      </div>
                    </nav>
                  </div>
                </div>
              </div>
            </div>
          </Headers>
        </div>
      </header>
    </>
  );
}

export default Header;
export const MemoizedHeader = React.memo(Header);
